import Man from "./man";
import Woman from "./woman";

export default {
    ...Man,
    ...Woman
}